import React, { useEffect, useState } from 'react';

// Split a step's narration into readable sentences.
export const sentences = (text) => text.replace(/\s+/g, ' ').trim().match(/[^.!?]+[.!?]+["”]?|[^.!?]+$/g)?.map((s) => s.trim()).filter(Boolean) || [text];

// Which sentence is being spoken: time is shared across sentences in proportion to their length.
export function activeSentence(parts, elapsedMs, durationMs) {
  const total = parts.reduce((a, p) => a + p.length, 0) || 1;
  let acc = 0;
  for (let k = 0; k < parts.length; k += 1) {
    acc += parts[k].length;
    if (elapsedMs < (acc / total) * durationMs) return k;
  }
  return parts.length - 1;
}

// Big-screen captions: the step's words in large type; the sentence being spoken is lit, the rest dimmed.
export function TourCaptions({ title, text, live }) {
  const parts = sentences(text);
  const [idx, setIdx] = useState(live ? 0 : -1);
  useEffect(() => {
    if (!live) { setIdx(-1); return undefined; }
    const tick = () => setIdx(activeSentence(parts, Date.now() - live.startedAt, live.durationMs));
    tick();
    const t = setInterval(tick, 120);
    return () => clearInterval(t);
  }, [live, text]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="fl-captions" role="status" aria-live="polite" data-testid="fl-tour-captions" data-active={idx}>
      <p className="fl-captions-title" data-testid="fl-tour-captions-title">{title}</p>
      <p className="fl-captions-text">
        {parts.map((s, k) => <span key={k} className={idx < 0 ? 'fl-cap-plain' : k === idx ? 'fl-cap-active' : k < idx ? 'fl-cap-done' : 'fl-cap-dim'} data-testid={k === idx ? 'fl-tour-caption-active' : undefined}>{s} </span>)}
      </p>
    </div>
  );
}
